import underConstruction from "assets/images/underConstruction.png";

const { Grid, Typography } = require("@mui/material");

const UnderConstruction = () => {
  return (
    <Grid
      container
      sx={{
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <img alt="as" src={underConstruction} height="200" width="200"></img>
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        Η σελίδα βρίσκεται υπο κατασκευή.
      </Typography>
    </Grid>
  );
};

export default UnderConstruction;
